import appApi from '../../../../../api/app-api';
import { ExternalExamRegistrationStudentDetails } from '../../../../../api/types/external-exams/registration/external-exam-student-registration-eligibility';

export const getExternalExamRegistrationsOperation = async (
  groupId: number,
  examId: number,
  branchIds: number[],
  setData: (data: ExternalExamRegistrationStudentDetails[]) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.getExternalExamRegistrations(
      groupId,
      examId,
      branchIds,
    );
    if (res.data.ok && res.data.body) {
      setData(res.data.body);
    } else {
      setData([]);
    }
    setLoading(false);
  } catch (e) {
    console.error(`getExternalExamRegistrationsOperation failed: ${e}`);
    setData([]);
    setLoading(false);
  }
};
